import BaseService from "@/services/Base-service";

class CompanyService {
  get controllerName() { return '/Company/'; }
  get sectionControllerName() { return '/CompanySection/'; }

  getSectionsByCompanyId(companyId) {
    return BaseService.get(this.sectionControllerName + 'GetList/' + companyId);
  }

  getCompanyList() {
    return BaseService.get(this.controllerName + 'GetCompanies');
  }

  getCompaniesByParentId(parentId) {
    return BaseService.get(this.controllerName + 'GetCompaniesByParentId/' + parentId);
  }

  getCompany(companyId) {
    return BaseService.get(this.controllerName + 'GetCompany/' + companyId);
  }

  createCompany(model) {
    return BaseService.post(this.controllerName + 'CreateCompany', model);
  }

  update(model) {
    return BaseService.post(this.controllerName + 'EditCompany', model);
  }

  deleteCompany(companyId) {
    return BaseService.post(this.controllerName + 'deleteCompany/' + companyId);
  }

  getCompanySections(companyId) {
    return BaseService.get(this.sectionControllerName + 'GetList/' + companyId);
  }

  getCompanySectionsForCustomer(companyId, customerId) {
    return BaseService.get(this.sectionControllerName + 'GetCompanySectionsForCustomer/', {companyId, customerId});
  }

  getSectionsForReferringByCompanyId(companyId) {
    return BaseService.get(this.sectionControllerName + 'GetSectionsForReferringByCompanyId/' + companyId);
  }

  addSection(model) {
    return BaseService.post(this.sectionControllerName + 'AddCompany', model);
  }

  deleteSection(sectionId) {
    return BaseService.post(this.sectionControllerName + 'DeleteCompany/' + sectionId);
  }

  updateSection(model) {
    return BaseService.post(this.sectionControllerName + 'UpdateCompany', model);
  }

  modifyCompanySectionsCustomers(vm) {
    return BaseService.post(this.sectionControllerName + 'ModifyCompanySectionsCustomers', vm);
  }

  getSection(id) {
    return BaseService.get(this.sectionControllerName + 'GetCompanySection/' + id);
  }

  getUserCompanies(companyId) {
    return BaseService.get(this.controllerName + 'GetCompaniesByUsersCompanyId/' + companyId);
  }
}
export default new CompanyService();